import { AppState } from 'reducers';

export const getStudioPlayers = (state: AppState) => state.studioPlayers;

export const getStudioPlayer = (state: AppState, id: string) => state.studioPlayers[id];
